module.exports = __webpack_public_path__ + "static/media/cel_suite_bedroom-790x444.3acd9d7a.jpg";